import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-help-amzn-redshift-checklist',
  templateUrl: './help-amzn-redshift-checklist.component.html',
  styleUrls: ['./help-amzn-redshift-checklist.component.scss']
})
export class HelpAmznRedshiftChecklistComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
